import { FileWithPreview } from 'js/components/data_sources/add_ds_form/FileUploadConfiguration/FileUploadConfiguration.types';
import {
  redesignStyles,
  SelectInput,
  SelectOption,
  SelectValue,
} from 'js/components/elements/rselect/ReactSelectUtils';
import UnsortedSelect from 'js/components/elements/rselect/UnsortedSelect';
import React from 'react';
import classes from 'new/components/flows/shared/customProcessor/TestCustomProcessor.module.scss';

interface Props {
  files: FileWithPreview[];
  path: string;
  onChange: (value: string) => void;
}

export default function UploadedFileSelector({ files, path, onChange }: Props) {
  const options = files.map((file) => ({ label: file.name, value: file.name }));
  const selected = options.find((o) => o.value === path) ?? null;

  return (
    <div className={classes.inputContainer} data-testid="uploaded-file-selector-container">
      <div className={classes.selectContainer}>
        <UnsortedSelect
          options={options}
          value={selected}
          onChange={(option: { value: string } | null) => onChange(option?.value ?? '')}
          components={{
            Input: SelectInput,
            Option: SelectOption,
            SingleValue: SelectValue,
          }}
          styles={redesignStyles}
          isClearable={false}
          backspaceRemovesValue={false}
          menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
          placeholder="Select a file..."
          data-testid="uploaded-file-selector"
        />
      </div>
    </div>
  );
}
